<div class="row">
  <div class="{{ images?.length === 1 ? 'col-m-10 offset-l-1 col-24' : 'col-m-12 offset-l-1 col-24' }}">
    <sd-gallery
      [brand]="brand"
      [isLoading]="isLoading"
      [hasBorder]="imageHasBorder"
      [images]="images"
      [galleryName]="overview?.title"
      [madeInData]="madeInData"
      [refurbishedData]="refurbishedData"
    />
  </div>
  <div class="c__content {{ images?.length === 1 ? 'col-m-14 col-l-9 offset-l-1 col-24' : 'col-m-12 col-l-8 offset-l-1 col-24' }}">
    <div [ngClass]="{ 'c__sticky': !isMobile }">
      <ng-container *ngTemplateOutlet="titleTemplate" />
      @if (!isLoading) {
        <div class="c__info row">
          <div class="col-24">
            <div class="c__product-info">
              <sd-product-info
                [displayStock]="!overview?.hasLocalStore && overview?.onSale && !!overview?.price && !isForfait"
                [isSSR]="isSSR"
                [stock]="overview?.stock"
                [isProductDetails]="true"
                [ecoTax]="overview?.ecoTax"
                [price]="overview?.price"
                [iAdvizeId]="overview?.iAdvizeId"
                [iAdvizeEnabled]="iAdvizeEnabled()"
                [dividedData]="overview?.dividedData"
                [discountedPrice]="overview?.discountedPrice"
                [klarnaData]="klarnaData"
                [recommendedPrice]="overview?.recommendedPrice"
                [isDiscountWithRecommendedPrice]="overview?.isDiscountWithRecommendedPrice"
                [isBundle]="isBundle"
                [isForfait]="isForfait"
                [isTaxesIncluded]="overview?.isTaxesIncluded"
                [reparabilityData]="overview?.reparabilityData"
                (repairabilityInfoClick)="onRepairabilityInfoClick()"
                (repairabilityLinkClick)="onRepairabilityLinkClick()"
                [promoQualiRepar]="overview?.promoQualiRepar"
                (openRecommendedPriceModal)="onOpenRecommendedPriceModal()"
                (dividedClick)="onDividedClick()"
                [deliveryText]="overview?.shipping"
                [pageTemplate]="pageTemplate"
              >
                @if (overview?.compatibleProduct?.active && overview?.compatibleProduct?.nbCompatibleProduct > 0 && !isMobile) {
                  <div class="c__compatibility-product" sd-compatible-product>
                    <sd-html
                      [html]="'product.compatibleProduct.title' | translate: {
                        nbCompatibleProduct: overview?.compatibleProduct.nbCompatibleProduct
                      }"
                    />
                    <a
                      href="#compatibleProduct"
                      sd-button
                      [isSecondary]="true"
                      [isSmall]="true"
                      (click)="selectLink('compatibleProduct', $event)"
                    >
                      <span>{{ 'product.compatibleProduct.verifyCompatibility'| translate }}</span>
                    </a>
                  </div>
                }
                @if (!isMobile && overview?.productFeatures?.title && overview?.productFeatures?.modalFeatures) {
                  <sd-product-features
                    sd-product-features
                    [productFeatures]="overview.productFeatures"
                    [isLoading]="isLoading"
                  />
                }
              </sd-product-info>
              @if (overview?.promoFreeGift?.length > 0) {
                @for (promoFreeGift of overview?.promoFreeGift; track $index) {
                  <sd-product-promo class="c__promo-free-gift" sd-promo [promo]="promoFreeGift" />
                }
              }
            </div>
          </div>
          @if (overviewForm) {
            <form novalidate
              [formGroup]="overviewForm"
              class="col-24 is-left c__form-cart-btn">
              @if (overview?.onSale && !!overview?.price) {
                <div class="c__cart-info">
                  @if (overview?.stock?.online) {
                    <button sd-button [brand]="brand" (click)="addToCart()" icon="icon-cart">
                      <span>{{ 'actions.cart.add' | translate }}</span>
                    </button>
                    <sd-form
                      select
                      class="is-block is-hidden"
                      [brand]="brand"
                      [items]="itemQty"
                      [labelTitle]="'product.a11y.quantity' | translate: { productName: overview?.title, productCode: overview?.code }"
                      [labelHidden]="false"
                      valueKey="value"
                      [selectedValue]="{value: overview?.quantity ? overview?.quantity : 1}"
                      libelleKey="value"
                      formControlName="quantitySelector"
                      [disabled]="quantityDisabled"
                    />
                  } @else if (!isBundle) {
                    <button sd-button type="button" [isSecondary]="true" (click)="stockNotify()">
                      <span>{{ 'product.stock.notify' | translate }}</span>
                      <span class="is-visually-hidden">{{ overview?.title }}</span>
                    </button>
                  }
                </div>
              }
              @if (overview?.hasLocalStore) {
                <div class="c__availability col-16">
                  <p class="c__online-availability">
                    <span class="c--pellet" [attr.data-background]="overview?.stock.online ? 'success-base' : 'error-base'"></span>
                    <span>{{ (overview?.stock?.online ? 'product.stock.onlineIn':'product.stock.onlineOut') | translate }}</span>
                  </p>
                  <p class="c__online-availability">
                    <span class="c--pellet" [attr.data-background]="overview?.stock?.store ? 'success-base' : 'error-base'"></span>
                    <span>{{ (overview?.stock?.store ? 'product.stock.storeIn':'product.stock.storeOut') | translate }} <b>{{ overview?.store?.name }}.</b></span>
                  </p>
                  <a (click)="onChangeStore()">
                    {{ 'product.stock.find' | translate }}
                  </a>
                </div>
              }
            </form>
          }
          @if (overview?.promo) {
            <sd-product-promo sd-promo [promo]="overview.promo" />
          }
          <div class="c__paypal">
            <ng-content select="[sd-additional-elements]" />
          </div>
          @if (overview?.dividedData) {
            <sd-divided-payment [dividedData]="overview.dividedData" (dividedClick)="onDividedClick()" />
          }
          <ng-content select="[sd-content]" />
          <div class="c__sections-container">
            <sd-section [title]="'pdp.sectionTitles.description' | translate" [type]="SectionTypeEnum.DESCRIPTION">
              <div section-modal-content>
                <p class="is-modal-section-title">{{ 'pdp.sectionTitles.description' | translate }}</p>
                @if (overview?.subtitle && !isMobile) {
                  <p class="is-modal-section-subtitle">
                    {{ overview?.subtitle }}
                  </p>
                }
                <ng-container sd-benefits-list>
                  @if (overview?.features?.length > 0) {
                    <ng-container *ngTemplateOutlet="featureList" />
                  } @else if (overview?.description?.description) {
                    <ng-container *ngTemplateOutlet="shortDesc" />
                  }
                </ng-container>
              </div>
            </sd-section>
            <ng-content select="[sections]" />
          </div>
          @if (overview?.reinsurancesPdp && overview?.onSale) {
            <sd-reinsurances-pdp
              (reinsurancesPdpClick)="onReinsurancesPdpClick($event)"
              [reinsurancesPdp]="overview?.reinsurancesPdp"
              [brand]="brand"
            />
          }
          <ng-content select="[sd-shoppable-content]" />
          @if (overview?.productLinkCard &&
          overview?.productLinkCard?.title &&
          overview?.productLinkCard?.price &&
          overview?.productLinkCard?.link?.url) {
            <sd-product-link-card [data]="overview?.productLinkCard" [hidePrice]="isSSR" />
          }
          @if (isMobile) {
            @if (overview?.productFeatures?.title && overview?.productFeatures?.modalFeatures) {
              <sd-product-features
                [productFeatures]="overview.productFeatures"
                [isLoading]="isLoading"
              />
            }
          }
          @if (overview?.bundles) {
            <div class="c__bundles">
              @if (overview.bundles.title) {
                <p class="is-caption">{{ overview.bundles.title }}</p>
              }
              @if (overview.bundles?.bundle) {
                <div class="c__packs d-flex">
                  @for (item of overview.bundles?.bundle; track $index) {
                    <sd-product-bundle
                      [productInfo]="item"
                      (openRecommendedPriceModal)="onOpenRecommendedPriceModal()"
                    />
                  }
                </div>
              }
              @if (overview.bundles.link) {
                <a [href]="overview.bundles.link.url">
                  {{ overview.bundles.link.linkName }} ({{ overview.bundles.nbPack }})
                </a>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

@if (isLoading && isMobile) {
  <sd-skeleton
    [appearance]="skeletonAppearanceEnum.heading"
    [sizeChangeMobile]="false"
    [count]="10"
  />
}

@if (overview?.compatibleProduct?.active && overview?.compatibleProduct?.nbCompatibleProduct > 0 && isMobile) {
  <div class="c__compatibility-product">
    <sd-html [html]="'product.compatibleProduct.title' | translate: {
      nbCompatibleProduct: overview?.compatibleProduct.nbCompatibleProduct
    }" />
    <a sd-button
      href="#compatibleProduct"
      [isSecondary]="true"
      [isSmall]="true"
      (click)="selectLink('compatibleProduct', $event)"
    >
      <span>{{ 'product.compatibleProduct.verifyCompatibility'| translate }}</span>
    </a>
  </div>
}

<ng-template #titleTemplate>
  @if (isLoading) {
    <sd-skeleton
      [appearance]="skeletonAppearanceEnum.heading"
      [sizeChangeMobile]="false"
      [count]="isMobile ? 2 : 40"
    />
  } @else {
    <div class="c__title-wrapper">
      @if (overview?.tags || overview?.brandLogo) {
        <div class="c__wrapper-tags">
          @if (overview?.tags) {
            <ul sd-list-inline class="c__tags">
              @for (tag of overview?.tags; track $index) {
                <li><sd-tag [brand]="brand" [tagData]="tag" /></li>
              }
            </ul>
          }
          @if (overview?.brandLogo) {
            <sd-banner class="c__brand-logo" [isFit]="true" [media]="overview?.brandLogo?.media" />
          }
        </div>
      }

      @let hasSeller = overview?.soldBy && overview?.onSale;

      <div class="c__ref-wrapper">
        <div class="c__ref-info is-caption">
          @if (hasSeller) {
            <sd-product-seller
              (toggleModalChange)="toggleProductSellerModal($event)"
              [isSmall]="false"
              [textSoldBy]="overview?.soldBy"
            />
          }
          <div class="c__ref-container">
            @if (overview?.code) {
              <p class="c__ref">
                @if (hasSeller) {
                  <span>| </span>
                }
                {{ "product.ref" | translate }} {{ overview?.code }}
              </p>
            }
            @if (overview?.refSAV) {
              <p class="c__ref c__ref-more {{hasSeller ? 'has-seller' : ''}}">
                @for (refSAV of overview?.refSAV | slice:0:currentNumberOfRefSavToDisplay; track $index) {
                  <ng-container *ngTemplateOutlet="templateRefSAV; context: {
                                refSAV: refSAV,
                                hasComma: $index < (currentNumberOfRefSavToDisplay - 1) && overview?.refSAV.length > 1
                              }"
                  />
                }
                @if (overview?.refSAV.length > numberOfRefSavToDisplay) {
                  @if (!_isOpenRef) {
                    <span>...</span>
                  }
                  <button type="button" class="c__toggle is-link" (click)="openReadMore()">
                    <span class="is-caption is-bold">
                      {{ (!_isOpenRef ? 'actions.readMore' : 'actions.showLess') | translate }}
                    </span>
                    <sd-icon [name]="_isOpenRef ? 'icon-arrow-up' : 'icon-arrow-down'" [size]="iconSize.xs" />
                  </button>
                }
              </p>
            }
          </div>
        </div>
      </div>
      <div class="c__main-title-wrapper">
        @if (overview?.title) {
          <sd-title [titleLevel]="titleLevel" customClass="brand--h3 c__title is-text-dark">
            {{ overview?.title }}
          </sd-title>
        }
        @if (showWishList) {
          <button
            sd-button-icon
            [brand]="brand"
            [titleHidden]="true"
            [buttonIconTitle]="(overview?.isInFavorite ? 'wishlist.remove' : 'wishlist.add') | translate"
            icon="icon-heart-filled"
            (click)="addToFavorite()"
            class="{{ overview?.isInFavorite ? 'is-active' : 'is-unactive' }} c__wishlist-button"
          ></button>
        }
      </div>
      @if (showSkeeper) {
        <div class="skeepers_product__stars" [attr.data-product-id]="objSkeeper?.productId"></div>
      }
    </div>
  }
</ng-template>

<ng-template #featureList>
    <div class="c__features">
      <ul sd-list-arrow>
        @for (item of overview?.features; track $index) {
          <li><sd-html [html]="item" tag="span" /></li>
        }
      </ul>
    </div>
</ng-template>

<ng-template #templateRefSAV let-refSAV="refSAV" let-hasComma="hasComma">
  {{ refSAV }}
  @if (hasComma) {
    <span>, </span>
  }
</ng-template>

<ng-template #shortDesc>
  <div class="c__short-desc">
    <p class="is-body-s c__description-collapsible">
      <sd-html #textDesc
        innerClass="is-collapsible is-inline"
        [html]="overview?.description.description"
        tag="span"
      />
    </p>
  </div>
</ng-template>
